import type { EnvironmentForm } from "./environmentForm";
import { inject } from "vue";
import { useI18n } from "vue-i18n";
import { DEBUG_TOOLS_CONTEXT } from "../types";
import { useDebugEnvironment } from "../useDebugEnvironment";
import { createEnvironmentForm } from "./environmentForm";

/** The Omgeving form of the open dialog, shared by the section body and its footer. */
export function useEnvironmentForm(): EnvironmentForm {
  const context = inject(DEBUG_TOOLS_CONTEXT, null);
  if (context === null) {
    throw new Error("The Omgeving section only works inside the debug tools dialog.");
  }
  const { t } = useI18n();
  const { presetLabel } = useDebugEnvironment(context.app, context.config);

  return context.sectionState("environment", () => createEnvironmentForm({
    app: context.app,
    config: context.config,
    t,
    presetLabel,
  }));
}
